import { Alert, Card, CardContent, Grid, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import React, { useState } from 'react';
import { useUpdateEffect } from 'react-use';

const RobotDataInitialForm = ({ loading, result, onSave }) => {
  const [step, setStep] = useState(0);
  const [off, setToggle] = useState(false);

  const handleClick = () => {
    if (step === 0) {
      setToggle(true);
    }
    setStep(step + 1);
    onSave(step > 0 && !off);
  };

  useUpdateEffect(() => {
    if (step === 2) {
      setStep(0);
      setToggle(false);
    }
    if (step > 0) {
      setTimeout(() => {
        setToggle(false);
      }, 1500);
    }
  }, [step, result]);

  return (
    <Card>
      <CardContent>
        <Grid container rowSpacing={1}>
          <Grid
            item
            xs={12}
            display="inline-flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6" component="h6">
              로봇 데이터 초기화
            </Typography>
            {/* <Button
              color={step ? 'error' : 'secondary'}
              variant="contained"
              disabled={off}
              onClick={handleClick}
            >
              초기화
            </Button> */}
            <LoadingButton
              color={step ? 'error' : 'secondary'}
              variant="contained"
              disabled={loading || off}
              loading={loading || off}
              onClick={handleClick}
            >
              초기화
            </LoadingButton>
          </Grid>
          {step > 0 && (
            <>
              <Grid item xs={12}>
                <Alert severity="warning">
                  초기화 버튼을 선택하면 다음과 같이 로봇 데이터가 초기화됩니다.
                </Alert>
              </Grid>
              <Grid item xs={12} sx={{ pl: 2 }}>
                <Typography>- 볼륨: 60 </Typography>
                <Typography>- 성향: 소극적 </Typography>
                <Typography>- 위치: 서울특별시 강남구 역삼동 </Typography>
                <Typography>- 방해금지모드: 실행 안함 </Typography>
                <Typography>
                  - 봇 데이터: 히스토리, 일정, 메시지, 사진, 음성일기 데이터
                  삭제
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default RobotDataInitialForm;
